import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/fraction-calculator',
  component: () => import('../../routes/FractionCalculator.svelte'),
  card: {
    id: 'fraction-calculator',
    title: 'Fraction Calculator',
    description: 'Add, subtract, multiply, and divide fractions. Shows step-by-step results and simplified answers.',
    icon: 'calculate',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/fraction-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Fraction Calculator – Add, Subtract, Multiply & Divide Fractions',
    description: 'Free fraction calculator to add, subtract, multiply, and divide fractions. Shows simplified results and decimal equivalents instantly.',
  },
};

export default meta;
